import { useState, useEffect, useRef } from 'react'
import { createClient } from '@supabase/supabase-js'
import { Auth } from '@supabase/auth-ui-react'
import { ThemeSupa } from '@supabase/auth-ui-shared'
import CoorayAppBar, { NavigationButtonType } from '../../shared/components/CoorayAppBar';
import { AnalyticsEvent } from '../../shared/analytics/AnalyticsEvent';
import { useNavigate } from 'react-router-dom';
import CoorayFooter from '../../shared/components/footer/CoorayFooter';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import AppFeatureIntroItem from '../../shared/components/login/AppFeatureIntroItem';
import { useGoogleLogin } from '@react-oauth/google';
import ExploreListItem from '../../shared/components/exploreplaces/ExploreListItem';
import { sendPageView } from '../../shared/utils/AnalyticsUtils';
import TallyForm from '../../shared/components/tally/TallyForm';

const supabase = createClient('https://twblyxzvdbhlhxxurpno.supabase.co', 'eeyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3Ymx5eHp2ZGJobGh4eHVycG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDMzNTMsImV4cCI6MjA3NTkxOTM1M30.cOz8DeHN7L00i3VN2wF5NXs2quw95Eaz3-8IQs4ltgw')

export default function LandingPage( { analytics } ) {

  const formRef = useRef(null)
  const [isUsingDarkMode, setIsUsingDarkMode] = useState(false)

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
      }

      setIsUsingDarkMode(window.matchMedia('(prefers-color-scheme: dark)').matches)
    })

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) {
      }
    })

    sendPageView(analytics, AnalyticsEvent.LOGIN_VIEW, {})

    return () => {
      subscription.unsubscribe()
      // clearTimeout(currentTimeout)
    }
  }, [])

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return <div>
      <div className="navbar bg-base-200 px-4">
          <div className="flex-1">
              <img className="h-12" src="https://twblyxzvdbhlhxxurpno.supabase.co/storage/v1/object/public/zipmap-resources/full-logo-lightning-light.png"/>
              <div className="text-xl font-bold px-2"></div>
          </div>
      </div>
      <div className="hero bg-base-200 pt-16 overflow-x-hidden">
        <div className="hero-content max-w-5xl text-left grid grid-cols-1 lg:grid-cols-7 gap-4">
          <div className='lg:col-span-4 flex flex-col items-center lg:items-start'>
            <h1 className="text-4xl lg:text-5xl font-bold text-center font-titan md:text-left pb-4">Turn your locations into a shareable map in 2 minutes</h1>
            <p className="text-lg lg:text-xl text-center md:text-left">For festivals, hostels, food trucks, pop-ups, and more</p>
            <p className="text-lg lg:text-xl text-center md:text-left pb-4">Buttery smooth map that loads in milliseconds.</p>
            <button className="btn h-auto btn-lg btn-primary normal-case w-max" onClick={() => {
                      scrollToForm()
                } }>
                  <div className='flex items-center gap-x-2 justify-between w-full'>
                  <svg className='w-6 h-6' viewBox="0 0 511.999 511.999">
                  <path fill="#B1532F" d="M64.022,295.136c-22.325,0-43.322-8.697-59.104-24.486c-6.531-6.531-6.531-17.112,0-23.642
                    l70.926-70.937c32.6-32.595,85.642-32.583,118.22,0c6.531,6.525,6.531,17.116,0,23.642l-70.937,70.937
                    C107.344,286.439,86.347,295.136,64.022,295.136z"/>
                  <path fill="#A64E2D" d="M253.18,511.99c-4.278,0-8.556-1.633-11.82-4.893c-15.794-15.788-24.491-36.78-24.491-59.116
                    c0-22.33,8.697-43.322,24.491-59.11l70.937-70.932c3.135-3.135,7.391-4.899,11.82-4.899l0,0c4.431,0,8.686,1.763,11.82,4.899
                    c32.589,32.595,32.589,85.626,0,118.22L265,507.091C261.735,510.357,257.457,511.99,253.18,511.99z"/>
                  <path fill="#E2E7EC" d="M292.59,384.926L409.27,268.25c16.782-16.784,30.683-35.698,41.679-55.989
                    c5.7-10.52,10.642-21.393,14.706-32.583L332.328,46.352c-11.191,4.064-22.064,9.006-32.583,14.706
                    c-20.292,10.997-39.206,24.898-55.991,41.681L127.084,219.42L292.59,384.926z"/>
                  <path fill="#CCD5E0" d="M465.654,179.679l-66.662-66.662L209.836,302.172l82.753,82.753l116.68-116.675
                    c16.782-16.784,30.683-35.698,41.679-55.989C456.647,201.742,461.591,190.868,465.654,179.679z"/>
                  <path fill="#6E6057" d="M438.399,73.609c-6.527-6.527-6.531-17.114,0-23.644l45.059-45.059
                    c6.531-6.531,17.117-6.527,23.644,0c6.527,6.527,6.53,17.114,0,23.644l-45.059,45.059C455.513,80.14,444.926,80.136,438.399,73.609z
                    "/>
                  <path fill="#615349" d="M462.043,73.609l45.059-45.059c6.531-6.531,6.527-17.117,0-23.644L438.398,73.61
                    C444.926,80.136,455.513,80.14,462.043,73.609z"/>
                  <path fill="#F3D583" d="M175.122,438.425c-10.03,22.069-29.87,39.123-53.278,45.476l-100.76,27.531
                    c-1.449,0.334-2.898,0.557-4.347,0.557c-4.347,0-8.694-1.672-11.816-4.904c-4.234-4.236-5.907-10.477-4.346-16.162l27.531-100.761
                    c3.121-11.703,9.029-22.515,16.831-31.655c7.914-9.14,17.722-16.608,28.757-21.623c20.397-9.14,43.358-8.917,62.864,0.669
                    c8.137,4.013,15.605,9.363,22.069,15.827c6.466,6.465,11.816,13.933,15.827,22.069C184.04,394.956,184.263,417.917,175.122,438.425z
                    "/>
                  <path fill="#EFC36C" d="M175.122,438.425c-10.03,22.069-29.87,39.123-53.278,45.476l-100.76,27.531
                    c-1.449,0.334-2.898,0.557-4.347,0.557c-4.347,0-8.694-1.672-11.816-4.904L158.626,353.38c6.466,6.465,11.816,13.933,15.827,22.069
                    C184.04,394.956,184.263,417.917,175.122,438.425z"/>
                  <path fill="#84BCFC" d="M324.117,235.182h0.109H324.117z M335.939,176.069c-19.546-19.546-51.387-19.547-70.934,0
                    c-9.457,9.457-14.659,22.067-14.659,35.467c-0.001,13.398,5.202,26.008,14.659,35.466c9.773,9.773,22.62,14.738,35.466,14.659
                    c12.847,0.079,25.694-4.886,35.467-14.659C355.486,227.456,355.485,195.614,335.939,176.069z"/>
                  <path fill="#78A8E2" d="M335.939,247.003c-9.773,9.773-22.62,14.739-35.467,14.659c-12.846,0.079-25.693-4.886-35.466-14.659
                    l70.934-70.934C355.485,195.614,355.486,227.456,335.939,247.003z"/>
                  <g>
                    <path fill="#BF6745" d="M127.08,219.417L83.626,312.65c-2.003,6.009-0.447,12.631,4.038,17.11l94.579,94.579
                      c3.189,3.189,7.456,4.898,11.822,4.898c1.774,0,3.56-0.283,5.29-0.861l93.214-43.473L127.08,219.417z"/>
                    <path fill="#BF6745" d="M465.654,179.679c14.878-40.98,18.631-85.824,9.795-130.002
                      c-1.317-6.624-6.499-11.795-13.117-13.117c-44.18-8.84-89.023-5.087-130.005,9.793c-11.191,4.064-22.064,9.006-32.583,14.706
                      l151.203,151.203C456.647,201.742,461.591,190.868,465.654,179.679z"/>
                  </g>
                  <g>
                    <path fill="#B1532F" d="M450.947,212.261c5.7-10.52,10.642-21.393,14.706-32.583c14.878-40.98,18.631-85.824,9.795-130.002
                      c-0.658-3.312-2.284-6.261-4.57-8.547l-95.531,95.531L450.947,212.261z"/>
                    <path fill="#B1532F" d="M134.956,377.052l47.287,47.287c3.189,3.189,7.456,4.898,11.822,4.898
                      c1.774,0,3.56-0.283,5.29-0.861l93.215-43.472l-82.733-82.732L134.956,377.052z"/>
                  </g>
                  </svg>
                    <span className='grow text-primary-content'>Get Started</span>
                  </div>
                  
            </button>
            <p className="text-sm text-center md:text-left pb-4 text-base-content/50 pt-2">No credit card required</p>
          </div>
          <div className='lg:col-span-3 pt-16 md:pt-0 flex justify-center items-center'>
              {isUsingDarkMode && <video className='rounded-3xl border-8 border-primary/10 border-solid drop-shadow-xl max-h-[800px] md:max-h-[800px]' autoPlay muted loop playsInline>
                  <source src={"https://twblyxzvdbhlhxxurpno.supabase.co/storage/v1/object/public/zipmap-resources/zipmap-demo-dark-small.mp4"} type="video/mp4"/>
                  Your browser does not support the video tag.
              </video>
              }
              {
              !isUsingDarkMode && <video className='rounded-3xl border-8 border-primary/10 border-solid drop-shadow-xl max-h-[800px] md:max-h-[800px]' autoPlay muted loop playsInline>
                  <source src={"https://twblyxzvdbhlhxxurpno.supabase.co/storage/v1/object/public/zipmap-resources/zipmap-demo-light-small.mp4"} type="video/mp4"/>
                  Your browser does not support the video tag.
              </video>
              }
          </div>
        </div>
      </div>
      <div className="hero bg-base-200 pt-16 px-4 overflow-x-hidden">
        <div className="hero-content max-w-5xl flex flex-col gap-4">
          <div className='w-full'>
            <h1 className="text-3xl lg:text-4xl font-bold text-center pb-4 font-titan">Try it</h1>
            <div className="card w-full bg-base-100 shadow-sm h-full">
            <div className="card-body">
              <a href="https://zipmap.io/christmas-on-a-great-street-2025" target="_blank" rel="noopener noreferrer">
                <h1 className="text-2xl lg:text-3xl font-bold text-center underline">🔗 zipmap.io/christmas-on-a-great-street-2025</h1>
              </a>
            </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hero bg-base-200 pt-16 px-4 overflow-x-hidden">
        <div className="hero-content max-w-5xl flex flex-col gap-4">
          <div className='w-full'>
            <h1 className="text-3xl lg:text-4xl font-bold text-center pb-4 font-titan">Here is how it works</h1>
          </div>
          <div className='grid grid-cols-1 lg:grid-cols-3 gap-2'>
            <div className='lg:col-span-1'>
            <div className="card w-full bg-base-100 shadow-sm h-full">
                <div className="card-body">
                <h2 className="text-2xl font-bold">📍</h2>
                  <div className="flex justify-between flex-col">
                    <h2 className="text-2xl font-bold">Add your locations</h2>
                    <h2 className="text-xl">Name, address, description (optional)</h2>
                    <span className="text-lg opacity-50">Time: 2 minutes</span>
                  </div>
                </div>
              </div>
            </div>

            <div className='lg:col-span-1'>
              <div className="card w-full bg-base-100 shadow-sm h-full">
                <div className="card-body">
                <h2 className="text-2xl font-bold">🔗</h2>
                  <div className="flex justify-between flex-col">
                    <h2 className="text-2xl font-bold">Get your link</h2>
                    <h2 className="text-xl">zipmap.io/your-link</h2>
                    <span className="text-lg opacity-50">Time: Instant</span>
                  </div>
                </div>
              </div>

            </div>
            
            <div className='lg:col-span-1'>
              <div className="card w-full bg-base-100 shadow-sm h-full">
                <div className="card-body">
                <h2 className="text-2xl font-bold">📱</h2>
                  <div className="flex justify-between flex-col">
                    <h2 className="text-2xl font-bold">Share it</h2>
                    <h2 className="text-xl">Instagram bio, WhatsApp, QR code, anywhere</h2>
                    <span className="text-lg opacity-50">Time: Done</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div className="hero bg-base-200 pt-16 px-4 overflow-x-hidden">
        <div className="hero-content max-w-5xl flex flex-col gap-4">
          <div className='w-full'>
            <h1 className="text-3xl lg:text-4xl font-bold text-center pb-4 font-titan">Perfect for</h1>
          </div>
          <div className='grid grid-cols-2 lg:grid-cols-3 gap-2'>
          <div className='lg:col-span-1'>
              <div className="card w-full bg-base-100 shadow-sm h-full">
                <div className="card-body">
                <h2 className="text-2xl font-bold">🎪</h2>
                  <div className="flex justify-between flex-col">
                    <h2 className="text-2xl font-bold">Festival organizers</h2>
                  </div>
                </div>
              </div>

            </div>
            <div className='lg:col-span-1'>
            <div className="card w-full bg-base-100 shadow-sm h-full">
                <div className="card-body">
                <h2 className="text-2xl font-bold">🚚</h2>
                  <div className="flex justify-between flex-col">
                    <h2 className="text-2xl font-bold">Food trucks</h2>
                  </div>
                </div>
              </div>
            </div>

            <div className='lg:col-span-1'>
              <div className="card w-full bg-base-100 shadow-sm h-full">
                <div className="card-body">
                <h2 className="text-2xl font-bold">👜</h2>
                  <div className="flex justify-between flex-col">
                    <h2 className="text-2xl font-bold">Market vendors (jewelry, clothing, crafts...)</h2>
                  </div>
                </div>
              </div>

            </div>
            
            <div className='lg:col-span-1'>
              <div className="card w-full bg-base-100 shadow-sm h-full">
                <div className="card-body">
                <h2 className="text-2xl font-bold">🎨</h2>
                  <div className="flex justify-between flex-col">
                    <h2 className="text-2xl font-bold">Artists and makers</h2>
                  </div>
                </div>
              </div>

            </div>

            <div className='lg:col-span-1'>
              <div className="card w-full bg-base-100 shadow-sm h-full">
                <div className="card-body">
                <h2 className="text-2xl font-bold">☕️</h2>
                  <div className="flex justify-between flex-col">
                    <h2 className="text-2xl font-bold">Pop-up shops</h2>
                  </div>
                </div>
              </div>

            </div>

            <div className='lg:col-span-1'>
              <div className="card w-full bg-base-100 shadow-sm h-full">
                <div className="card-body">
                <h2 className="text-2xl font-bold">📍</h2>
                  <div className="flex justify-between flex-col">
                    <h2 className="text-2xl font-bold">Mobile services</h2>
                  </div>
                </div>
              </div>

            </div>
            <div className='lg:col-span-1'>
              <div className="card w-full bg-base-100 shadow-sm h-full">
                <div className="card-body">
                <h2 className="text-2xl font-bold">🏠</h2>
                  <div className="flex justify-between flex-col">
                    <h2 className="text-2xl font-bold">Hostels</h2>
                  </div>
                </div>
              </div>

            </div>
            <div className='lg:col-span-1'>
              <div className="card w-full bg-base-100 shadow-sm h-full">
                <div className="card-body">
                <h2 className="text-2xl font-bold">🚌</h2>
                  <div className="flex justify-between flex-col">
                    <h2 className="text-2xl font-bold">Tour operators</h2>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      {/* <div className="hero bg-base-200 pt-16">
        <div className="hero-content max-w-5xl text-left grid grid-cols-1 lg:grid-cols-7 gap-4">
          <div className='lg:col-span-4'>
            <h1 className="text-3xl lg:text-4xl font-bold flex pb-4 font-titan">Find by Filters and Sort</h1>
            <p className="text-md lg:text-xl flex pt-2">Quickly locate a specific place from your saved collection using flexible filters 🔍 and sort features. You can even sort by the places nearest to your current location 📍.</p>
          </div>
          <div className='lg:col-span-3'>
              {
              isUsingDarkMode && <video className='w-full rounded-xl border-8 border-base-100 border-solid drop-shadow-lg' controls muted loop>
                  <source src={"https://twblyxzvdbhlhxxurpno.supabase.co/storage/v1/object/public/cooray-tutorial-resources/videos/roambear_app_filters_sort_demo_dark.mp4"} type="video/mp4"/>
                  Your browser does not support the video tag.
              </video>
              }
              {
              !isUsingDarkMode && <video className='w-full rounded-xl border-8 border-base-100 border-solid drop-shadow-lg' controls muted loop>
                  <source src={"https://twblyxzvdbhlhxxurpno.supabase.co/storage/v1/object/public/cooray-tutorial-resources/videos/roambear_app_filters_sort_demo_light.mp4"} type="video/mp4"/>
                  Your browser does not support the video tag.
              </video>
              }
          </div>
        </div>
      </div> */}
      {/* <div className="hero bg-base-200 pt-16">
        <div className="hero-content max-w-5xl text-left">
          <div className="flex flex-col place-content-center">
            <h1 className="text-3xl lg:text-5xl font-bold flex pt-32 font-titan"><span className='grow'>Oh so easy, even your Jack Russell knows how to use it.</span>
            <img src="https://twblyxzvdbhlhxxurpno.supabase.co/storage/v1/object/public/cooray-shared-resources/screenshots/roambear_intro_jrt.png" alt="" class="self-center w-16 h-16 lg:w-24 lg:h-24 mx-1" />
            </h1>
            <p className="py-6 text-md lg:text-xl">
              Yet so powerful that you'll want to ditch whatever you're using now.
            </p>
          </div>
        </div>
      </div> */}
      {/* <div className="hero bg-base-200">
        <div className="hero-content text-left">
          <div className="max-w-5xl grid grid-cols-3 md:grid-cols-6 gap-2 md:px-4 pb-20 items-stretch">
              {
                  promoFeatures.map((feature) => {
                      return <div className="col-span-3" key={feature.key}>
                          <AppFeatureIntroItem title={`${feature.title}`} 
                          description={feature.description}
                          image={feature.photo}
                          isUsingDarkMode={isUsingDarkMode}
                          />
                      </div>
                  })
              }
          </div>
        </div>
      </div> */}
      <div className="hero bg-base-200 pt-16" ref={formRef}>
        <div className="hero-content text-left">
          <div className="max-w-4xl min-h-[40vh] flex flex-col place-content-center">
            <h1 className="text-3xl lg:text-5xl font-bold text-center pb-4 font-titan">Ready to get started?</h1>
            <TallyForm isUsingDarkMode={isUsingDarkMode}/>
            </div>
        </div>
      </div>
      <CoorayFooter background='bg-base-200' />
    </div>
}